import { Box } from "@qws-org/ui-kit";
import type { FC } from "react";

type PaginationProgressProps = {
  duration: number;
  resetKey: number | string;
  state: "fulfilled" | "current" | "future";
};

export const PaginationProgressDot: FC<PaginationProgressProps> = ({
  duration,
  resetKey,
  state,
}) => {
  const width =
    state === "fulfilled" ? "100%" : state === "future" ? "0%" : "100%";

  return (
    <Box
      height={6}
      width={120}
      border={{ radius: "card" }}
      bg="surface-disabled"
      className="overflow-hidden"
    >
      <Box
        key={resetKey}
        height="100%"
        bg="surface-neutral-light"
        width={width}
        border={{ radius: "card" }}
        animation={
          state === "current"
            ? {
                name: "keyframes",
                duration: duration / 1000,
                transition: "linear",
                direction: "forwards",
                keyframes: {
                  "0%": { width: "0%" },
                  "100%": { width: "100%" },
                },
              }
            : undefined
        }
      />
    </Box>
  );
};
